import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheveronDownIcon } from '@wkda/icons';
import cx from 'classnames';
import { CheckBox } from './CheckBox';
import * as styles from './Item.module.scss';
import { Button } from '@wkda/styleguide';
export function Item({ onClick, isOpen, isSelected, onSelect, content, name, value, }) {
    const selectionHandler = onSelect || (() => null);
    function onClickHandler(e) {
        e.preventDefault();
        onClick();
    }
    return (_jsx("div", { className: styles.item, children: _jsxs("div", { className: styles.controls, children: [_jsx(CheckBox, { className: styles.checkBox, isChecked: isSelected, toggle: selectionHandler, name: name, value: value }), _jsxs("div", { className: styles.contentWrapper, children: [_jsx("span", { className: cx(styles.title, { [styles.titleSelected]: isSelected }), onClick: selectionHandler, children: content.title }), _jsx("p", { className: cx(styles.content, {
                                [styles.contentCollapsed]: !isOpen,
                            }), dangerouslySetInnerHTML: {
                                __html: content.description,
                            } })] }), _jsx(Button, { className: "btn--icon", onClick: onClickHandler, children: _jsx(CheveronDownIcon, { className: cx(styles.chevron, {
                            [styles.chevronToggled]: isOpen,
                        }) }) })] }) }));
}
